// extracted by mini-css-extract-plugin
export default {"gridItemTitle":"GridItem_gridItemTitle__cmek+","gridItemGraph":"GridItem_gridItemGraph__dx9In"};